import { GlassMaterialCode, SheetMaterialCode } from "../constants";

export const isOverdoorGlassMaterialType = (type: string | null) =>
    type === GlassMaterialCode;
export const isOverdoorAluminiumMaterialType = (type: string | null) =>
    type == SheetMaterialCode;
